import { createStyles } from '@utils/styles'

const styles = createStyles({
  section: {
    p: { xs: 2.5, md: 3 },
    borderRadius: '12px',
    border: '1px solid',
    borderColor: 'border.light',
    bgcolor: 'background.default',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },

  grid: {
    display: 'grid',
    gap: 2,
    overflow: 'visible',
  },
  item: {
    p: { xs: 1.5, md: 2 },
    borderRadius: '10px',
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'border.light',
    minWidth: 0,
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
  },
  itemLink: {
    cursor: 'pointer',
    transition:
      'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: 2,
      borderColor: 'primary.main',
    },
  },
})

export default styles
